import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/information-icon.svg'


const _hoisted_1 = ["data-test", "width"]

import { computed } from "vue";
import { Tooltip } from "uiv";


export default /*#__PURE__*/_defineComponent({
  __name: 'info-icon',
  props: {
    tooltipText: {},
    name: {},
    iconWidth: {}
  },
  setup(__props: any) {

const props = __props;

const iconWidth = computed(() => {
  return props.iconWidth || "16";
});

return (_ctx: any,_cache: any) => {
  return (props.tooltipText)
    ? (_openBlock(), _createBlock(_unref(Tooltip), {
        key: 0,
        text: props.tooltipText,
        class: "information-tooltip",
        "data-test": `${props.name}-tooltip`
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "information",
            "data-test": `${props.name}-tooltip-icon`,
            width: iconWidth.value,
            tabindex: "0"
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }, 8, ["text", "data-test"]))
    : _createCommentVNode("", true)
}
}

})